import { categories } from "@/mocks/content";

export default function Categories() {
  return (
    <section id="categories" className="scroll-mt-20 bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-600">
            <i className="ri-layout-grid-line"></i> Channels
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">内容频道分类</h2>
          <p className="mt-2 text-sm text-foreground-600">
            按主题挑选你关心的瓜料，点击进入对应频道持续追踪。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#featured"
              className="group flex cursor-pointer items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-0.5 hover:border-accent-200"
            >
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-xl text-white ${c.color}`}>
                <i className={c.icon}></i>
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-700">{c.name}</h3>
                <p className="mt-1 truncate text-xs text-foreground-500">{c.desc}</p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="whitespace-nowrap text-xs font-medium text-foreground-400">{c.count}</span>
                <i className="ri-arrow-right-line text-foreground-300 transition group-hover:translate-x-1 group-hover:text-accent-600"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}